<button
  class="BtnFilled BtnFilled--blue"
  #tooltip="matTooltip"
  matTooltipPosition="above"
  matTooltipClass="mat-tooltip-above"
  [matTooltip]="message"
>
  <ng-content></ng-content>
</button>
